export default "__VITE_ASSET__NSUFsDzS__"